import styled from 'styled-components';

export const FileInput = styled.input`
  display: none;
`;
